import { SystemSettingsDto, SystemSettingsFilter } from '@sweatpals/shared';
import { AxiosInstance } from 'axios';

export class SystemSettingsService {
	private readonly basePath = 'system-settings';

	constructor(private readonly httpClient: AxiosInstance) {}

	public async getPublicSystemSettings(filter: SystemSettingsFilter): Promise<SystemSettingsDto[]> {
		const { data } = await this.httpClient.get<SystemSettingsDto[]>(`${this.basePath}/public`, { params: filter });
		return data;
	}
}
